import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/layout/Header';
import ForgotPasswordModal from '../components/modals/ForgotPasswordModal';
import brasao from '../assets/img/brasao.png';
import '../assets/css/login.css';

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  // Se o usuário já estiver autenticado, redireciona para o dashboard
  if (isAuthenticated) {
    return <Navigate to="/painel/dashboard" replace />;
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email || !password) {
      setError('Por favor, preencha o email e a senha.');
      setLoading(false);
      return;
    }

    // Chama a função login e aguarda o objeto de resposta
    const response = await login(email, password);

    setLoading(false);

    if (response.success) {
      navigate('/painel/dashboard');
    } else {
      // Define a mensagem de erro específica retornada pelo AuthContext
      setError(response.message);
    }
  };

  return (
    <div className="login-page-container">
      <Header />
      <div className="login-content-wrapper">
        <h1 className="hero-title-top">NAI - Movimentação</h1>
        
        {/* Conteúdo copiado do LoginModal */}
        <div className="login-modal-content">
          <div className="login-modal-header">
            <img 
              src={brasao}
              alt="Brasão SSE-DF" 
              className="brasao-logo"
            />
            <h2 className="login-modal-title">Acessar o Sistema</h2>
          </div>
          <div className="login-modal-body">
            <form onSubmit={handleLogin} noValidate autoComplete="off">
              <div className="form-floating mb-4">
                <input
                  type="email"
                  id="email"
                  className="form-control glass-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder=""
                  autoComplete="off"
                  required
                />
                <label htmlFor="email">Email</label>
              </div>
              <div className="form-floating mb-4">
                <input
                  type="password"
                  id="password"
                  className="form-control glass-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder=""
                  autoComplete="new-password"
                  required
                />
                <label htmlFor="password">Senha</label>
              </div>

              {error && <p className="text-danger text-center small">{error}</p>}

              <div className="d-grid mt-4">
                <Button type="submit" variant="primary" size="lg" disabled={loading}>
                  {loading ? 'Entrando...' : 'Entrar'}
                </Button>
              </div>
              <div className="d-grid mt-4 justify-content-center">
                <a 
                  href="#" 
                  onClick={(e) => { 
                    e.preventDefault(); 
                    setShowForgotPassword(true);
                  }}
                  className="text-decoration-none text-light"
                >
                  Esqueceu sua senha?
                </a>
              </div>
            </form>
          </div>
          <div className="login-modal-footer justify-content-center">
            <p className="mb-0 text-light">Não tem uma conta? <a href="#" className="text-decoration-none" style={{color: 'var(--cor3)'}}>Solicitar acesso</a></p>
          </div>
        </div>
      </div>
      
      {/* Modal de Recuperação de Senha */}
      <ForgotPasswordModal 
        show={showForgotPassword}
        onHide={() => setShowForgotPassword(false)}
        email={email}
      />
    </div>
  );
}
export default LoginPage;